module.exports = __webpack_public_path__ + "media/images/emoticons/aquarius-b7f62e30b139188cf67092ef1c9462c3.gif";